export const ROLE_ADMIN = 'admin'
export const ROLE_MEDICAL = 'medical-manager'
export const ROLE_TECHNICAL = 'technical-manager'
export const ROLE_STAFF = 'staff'
export const ROLE_VISITOR = 'visitor'
export const ROLE_ALERT_OBSERVER = 'alert-observer'

export const roles = [
  ROLE_ADMIN,
  ROLE_MEDICAL,
  ROLE_TECHNICAL,
  ROLE_STAFF,
  ROLE_VISITOR,
  ROLE_ALERT_OBSERVER,
]
